export default __webpack_public_path__ + "static/media/sepa-mandate.ef0f837d.jpg";